import styled from 'styled-components'
import React from 'react'
import PropTypes from 'prop-types'
import { Box, Text, Flex, getPaletteColor, Tooltip } from 'pcln-design-system'

/** = Styles */
const CenteredBox = styled(Box)`
  text-align: center;
`

const StopDetails = styled(Text.p)`
  display: none;
  font-size: 11px;
  font-weight: 500;
  line-height: 13px;

  ${(props) => props.theme.flyQueries.desktoplg} {
    display: block;
  }
`

const Dot = styled(Box)`
  display: block;
  margin: 0 auto;
  background-color: ${getPaletteColor('border.dark')};
  height: 6px;
  width: 6px;
  transform: translateY(-50%);
  line-height: 6px;

  ${(props) => props.theme.flyQueries.mobilelg} {
    height: 8px;
    width: 8px;
    line-height: 8px;
  }
`

const StyledToolTip = styled(Tooltip)`
  white-space: nowrap;
`

/** = Component */
export default class StopItem extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showHover: false,
    }
  }

  showToolTip() {
    this.setState({
      showHover: true,
    })
  }

  hideToolTip() {
    this.setState({
      showHover: false,
    })
  }

  render() {
    const { location, stopTitle, duration, isShelfItinerary } = this.props
    const tooltipText = `${duration} layover, ${stopTitle}`
    if (!location) {
      return null
    }

    return (
      <CenteredBox
        data-test='stop-item'
        onMouseEnter={() => this.showToolTip()}
        onMouseLeave={() => this.hideToolTip()}
      >
        <Dot borderRadius='full' />
        {this.state.showHover && (
          <Flex justifyContent={'center'}>
            <StyledToolTip bg='background.darkest' color='text.lightest' zIndex={1} top center>
              {tooltipText}
            </StyledToolTip>
          </Flex>
        )}
        <StopDetails m={0} data-test='stop-text'>
          <Text.p m={0}>{location}</Text.p>
          {!isShelfItinerary && duration}
        </StopDetails>
      </CenteredBox>
    )
  }
}

StopItem.propTypes = {
  location: PropTypes.string.isRequired,
  duration: PropTypes.string,
  stopTitle: PropTypes.string,
  isShelfItinerary: PropTypes.bool,
}

StopItem.contextTypes = {
  SETI: PropTypes.object,
}
